export const statuses = {
  active: { color: '#F0640C', translatedStatus: 'В пути' },
  incoming: { color: '#FF9F63', translatedStatus: 'Ожидает отправления' },
  arrived: { color: '#FF9F63', translatedStatus: 'Подтверждение' },
  delivered: { color: '#88D33C', translatedStatus: 'Доставлено' },
  canceled: { color: '#8B949B', translatedStatus: 'Отменено' },
}
